import {
  useStatisticsOfActivities,
  me,
  flex,
  maxWidth,
} from '@openeducation/hr-rn-components';
import React, { memo } from 'react';
import { View } from 'react-native';

import StatisticsOfActivities from './statistics-of-activities';

interface StatisticsOfActivitiesProps {
  contactId?: string;
  languageCode?: string;
  onGroupClassAttendancePress?: () => void;
  isGroupClassAttendanceEnabled?: boolean;
}

const OEStatisticsOfActivities = ({
  contactId,
  languageCode,
  onGroupClassAttendancePress,
  isGroupClassAttendanceEnabled,
}: StatisticsOfActivitiesProps) => {
  const {
    activitiesChartData,
    chartBarsColor,
    ...statisticsOfActivitiesProps
  } = useStatisticsOfActivities({ contactId, languageCode });

  return (
    <View style={[maxWidth(830), flex('flex-1'), me(32)]}>
      <StatisticsOfActivities
        isGroupClassAttendanceEnabled={isGroupClassAttendanceEnabled}
        onGroupClassAttendancePress={onGroupClassAttendancePress}
        activitiesChartData={activitiesChartData}
        chartBarsColor={chartBarsColor}
        statisticsOfActivitiesProps={statisticsOfActivitiesProps}
        scalesHeight={145}
      />
    </View>
  );
};

export default memo(OEStatisticsOfActivities);
